import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';

interface BaseTintColorOptionProps {
  tintColor: RGBA;
  onClickColorFill(): void;
  className?: string;
}

export function BaseTintColorOption({className = '', ...props}: BaseTintColorOptionProps): ReactElement<any> {
  const getColorData = (): ColorFillStorage[] => {
    return [
      {
        id: 'tint-color-object',
        color: getColorObjectArrayFromFillColor([props.tintColor]),
      },
    ];
  };

  const getTintColorOption = (): ReactElement<any> => {
    return (
      <ContextualMenuColorFillOption
        id="item-tint-color-option"
        className={className}
        label={window.i18next.t('pmwjs_color')}
        data={getColorData()}
        onClick={(): void => {
          props.onClickColorFill();
        }}
      />
    );
  };
  return getTintColorOption();
}
